<template>
  <Modal
      :loading="loading"
      :icon="icon"
      @close="close"
  >
    <template #header>
      {{ modalTitle }}
    </template>

    {{ modalMessage }}

    <template #footer>
      <Button class="btn-primary btn-bordered"
              @click="close"
      >
        {{ $t('global.cancel') }}
      </Button>

      <Button class="btn-primary"
              :class="confirmButtonClass"
              @click="confirm"
      >
        {{ confirmButtonText || $t('global.confirm') }}
      </Button>
    </template>
  </Modal>
</template>
<script setup>
import Modal from "@/js/Components/Modal/Modal.vue";
import Button from "@/js/Elements/Button.vue";
import {computed} from "vue";
import {useI18n} from "vue-i18n";

const emit = defineEmits(['close']);
const props = defineProps({
  title: String,
  message: String,
  loading: Boolean,
  icon: String,
  confirmButtonClass: String,
  confirmButtonText: String,
});

const { t } = useI18n();
const modalTitle = computed(() => {
  return props.title || t('global.action_confirmation');
});

const modalMessage = computed(() => {
  return props.message || t('front.are_you_sure');
});

function close() {
  emit('close');
}

function confirm() {
  emit('confirm', { close });
}
</script>